export enum CourseProgressTabEnum {
  IN_PROGRESS = 'IN_PROGRESS',
  CONCLUDED = 'CONCLUDED',
}
